<div class="flex flex-col h-full overflow-y-auto">
  @let linkClasses =
    'group flex items-center py-4 px-4 border-b font-semibold text-sm md:text-base hover:bg-walden-200';

  @for (route of routes(); track route.title) {
    @if (route?.url && route.url.startsWith('http')) {
      <a
        [class]="linkClasses"
        [href]="route.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ route.title }}
        <span class="hidden group-hover:inline ml-auto">
          <wu-icon name="linkIcon" />
        </span>
      </a>
    } @else {
      <a
        [class]="linkClasses"
        [routerLink]="route.url"
        routerLinkActive="bg-walden-200 cursor-default"
        (click)="onNavClick(route.url)"
      >
        {{ route.title }}
      </a>
    }
  }

  <wu-qualtricks></wu-qualtricks>
</div>
